import { Button, Center, Title } from "@mantine/core";

export const SuccessPage = ({ end }: any) => {
  return (
    <Center m="xl" p="xl">
      <Title order={4} m="xl">
        Submitted with success!
      </Title>
      <Button color="orange" onClick={end} m="xl">
        Leave
      </Button>
    </Center>
  );
};
